import { http } from '@pendo/http';

export const feedbackApi = '/api/s/_SID_/feedback';
// Endpoints should be called through VUEX ONLY to ensure the state store is
// up-to-date and that we only call the API when needed.

export function fetchStatuses () {
    return http.get(`${feedbackApi}/vendor/statuses`);
}
